"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Autocomplete = Autocomplete;
exports.Item = Item;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _LocationOn2 = _interopRequireDefault(require("@mui/icons-material/LocationOn"));
var _MyLocation2 = _interopRequireDefault(require("@mui/icons-material/MyLocation"));
var _Explore2 = _interopRequireDefault(require("@mui/icons-material/Explore"));
var _Autocomplete2 = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _GridLegacy2 = _interopRequireDefault(require("@mui/material/GridLegacy"));
var _TextField2 = _interopRequireDefault(require("@mui/material/TextField"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _models = require("../../models");
var _services = require("../../services");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const useStyles = (0, _makeStyles.default)({
  noOptionsHidden: {
    display: 'none'
  }
});
function Autocomplete({
  center: mapCenter,
  nbResults,
  id,
  margin,
  size,
  required,
  disabled,
  disableFloatingLabel,
  disableClearable,
  customOptions,
  hideCustomOptionsOnSearch,
  defaultValue,
  error,
  inputProps,
  isManualInputInvalid,
  label: _label,
  onInputChange,
  onSelect,
  onCustomOptionSelect,
  ...props
}) {
  const [value, setValue] = (0, _react.useState)(null);
  const [inputValue, setInputValue] = (0, _react.useState)('');
  const [options, setOptions] = (0, _react.useState)([]);
  const [loading, setLoading] = (0, _react.useState)(false);
  const [invalidInput, setInvalidInput] = (0, _react.useState)(false);
  const fetch = (0, _react.useMemo)(() => (0, _debounce.default)((request, callback, center) => {
    _services.GeocoderService.autocomplete(request, {
      center,
      nbResults
    }, callback);
  }, 700), []);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const classes = useStyles();
  (0, _react.useEffect)(() => {
    if (defaultValue === null) setInputValue('');
    setValue(defaultValue || null);
    setOptions(defaultValue ? [defaultValue] : []);
  }, [defaultValue]);
  (0, _react.useEffect)(() => {
    let active = true;
    if (!inputValue || value && !value.addressDetail || value && value.strPoint === inputValue || value && value.address === inputValue) return undefined;
    fetch(inputValue, places => {
      if (active) {
        let newOptions = [];
        if (value) newOptions = [value];
        if (places) newOptions = [...newOptions, ...places];
        setOptions(newOptions);
        setLoading(false);
      }
    }, mapCenter);
    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);
  function getKey(place) {
    const {
      id
    } = place;
    if (!id) return '';
    const isGeolocation = id === 'geolocation';
    if (place instanceof _models.Ride) return `ride-${id}`;
    if (place instanceof _models.BikeRoute) return `bike-route-${id}`;
    if (isGeolocation) return `geolocation`;
    if (place instanceof _models.UserPlace) return `user-place-${id}`;
    if (place instanceof _models.Place) return `place-${id}`;
    return '';
  }
  const label = _label || t('commons.actions.search_address');
  return /*#__PURE__*/_react.default.createElement(_Autocomplete2.default, _extends({
    autoComplete: true,
    filterSelectedOptions: true,
    includeInputInList: true,
    classes: !inputValue || value ? {
      noOptions: classes.noOptionsHidden
    } : {},
    clearOnBlur: false,
    clearText: t('commons.actions.remove') || '',
    disableClearable: disableClearable,
    disabled: disabled,
    filterOptions: x => x,
    forcePopupIcon: Boolean(inputValue && !value),
    getOptionKey: option => option.id || -1,
    getOptionLabel: option => typeof option === 'string' ? option : option instanceof _models.Ride || option instanceof _models.BikeRoute ? option.title || '' : option.address,
    id: id || 'places-autocomplete',
    inputValue: inputValue,
    isOptionEqualToValue: (option, value) => {
      if (option instanceof _models.UserPlace && value instanceof _models.UserPlace && option.id === value.id) return true;
      if (option instanceof _models.Place && value instanceof _models.Place && option.id === value.id) return true;
      if (option instanceof _models.Ride && value instanceof _models.Ride && option.id === value.id) return true;
      if (option instanceof _models.BikeRoute && value instanceof _models.BikeRoute && option.id === value.id) return true;
      return false;
    },
    loading: Boolean(inputValue) && !value && loading,
    loadingText: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.loading"
    }),
    noOptionsText: inputValue && /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: "commons.no_result_found"
    }),
    onBlur: () => {
      if (isManualInputInvalid && inputValue !== '' && value === null) {
        setInvalidInput(true);
      }
    },
    onChange: (event, newValue) => {
      if (newValue instanceof _models.Ride || newValue instanceof _models.BikeRoute) {
        setOptions([]);
        setInputValue('');
        setValue(null);
        onInputChange?.('');
        onCustomOptionSelect?.(newValue);
        return;
      }
      setOptions(newValue ? [newValue, ...options] : options);
      setValue(newValue);
      onSelect?.(newValue);
    },
    onFocus: () => {
      if (isManualInputInvalid && invalidInput) {
        setInvalidInput(false);
      }
    },
    onInputChange: (event, newInputValue) => {
      setLoading(true);
      setOptions([]);
      setInputValue(newInputValue);
      onInputChange?.(newInputValue);
    },
    options: [...((!hideCustomOptionsOnSearch || !inputValue) && customOptions?.filter(option => {
      if (!inputValue) return true;
      if (option instanceof _models.Ride || option instanceof _models.BikeRoute || option instanceof _models.UserPlace) return option.title && option.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 || false;
      return option.address && option.address.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 || false;
    }) || []), ...options],
    renderInput: params => /*#__PURE__*/_react.default.createElement(_TextField2.default, _extends({
      autoComplete: "off",
      label: disableFloatingLabel ? undefined : label,
      placeholder: disableFloatingLabel ? label || '' : undefined,
      required: required,
      variant: "outlined"
    }, inputProps, params, {
      fullWidth: true,
      error: error || invalidInput,
      margin: margin || 'dense',
      slotProps: {
        input: {
          ...inputProps?.slotProps?.input,
          ...params.InputProps
        },
        inputLabel: {
          ...inputProps?.slotProps?.inputLabel,
          ...params.InputLabelProps
        }
      }
    })),
    renderOption: (props, place) =>
    /*#__PURE__*/
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    _react.default.createElement(_GridLegacy2.default, _extends({
      container: true,
      alignItems: "center"
    }, props, {
      key: getKey(place) || props.key
    }), /*#__PURE__*/_react.default.createElement(Item, {
      place: place
    })),
    size: size,
    style: {
      width: '100%'
    },
    value: value
  }, props));
}
function Item({
  place
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const isGeolocation = place.id === 'geolocation';
  const Icon = place instanceof _models.Ride || place instanceof _models.BikeRoute ? _Explore2.default : isGeolocation ? _MyLocation2.default : place instanceof _models.UserPlace ? _models.userPlaceTypes[place.type].Icon : null;
  const PlaceTypeIcon = !Icon && 'placeType' in place && place.placeType && _models.placeTypeIcons[place.placeType] || null;
  let title;
  let subtitle;
  if (place instanceof _models.Ride) {
    const {
      title: _title,
      from,
      to
    } = place;
    title = _title || '';
    if (from?.addressDetail) {
      subtitle = from.address;
      if (to?.addressDetail && to.address.localeCompare(from.address) !== 0) {
        subtitle += ` < > ${to.address}`;
      }
    }
  } else if (place instanceof _models.BikeRoute) {
    title = place.title;
  } else {
    title = place.addressDetail?.primaryText || '';
    subtitle = place.addressDetail?.secondaryText;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    item: true,
    alignItems: "center",
    display: "flex",
    style: {
      width: '48px'
    }
  }, Icon ? /*#__PURE__*/_react.default.createElement(Icon, {
    color: "primary"
  }) : PlaceTypeIcon ? /*#__PURE__*/_react.default.createElement(PlaceTypeIcon, {
    color: "action"
  }) : /*#__PURE__*/_react.default.createElement(_LocationOn2.default, {
    color: "action"
  })), /*#__PURE__*/_react.default.createElement(_GridLegacy2.default, {
    item: true,
    xs: true,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    style: {
      minHeight: '36px',
      width: 'calc(100% - 48px)'
    }
  }, isGeolocation ? /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: "commons.my_location"
  }) : place instanceof _models.UserPlace ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, place.title || _models.userPlaceTypes[place.type].titleKey && t(_models.userPlaceTypes[place.type].titleKey || '') || '', place.addressDetail?.primaryText && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "body2"
  }, place.addressDetail.primaryText)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title, subtitle && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    color: "textSecondary",
    variant: "body2"
  }, subtitle))));
}